"use client"

import React from 'react'
import styles from './styles.module.scss'
import SvgBag from '@/src/assets/svgs/collection/bag.svg'
import ActionButton from '@/src/components/misc/action-elements/action-button/action-button'
import AddMore from '../../add-more/add-more'
import { useCurrentProduct } from '@/src/context/product/current-product-context'
import { useAddItem } from '@/src/hooks/shopping-cart/useAddItem'
import { useMerchant } from '@/src/context/merchant/merchant-context'

export default function ProductBottom() {
    const { canAddItem, currentProduct, price, setAmountProducts, amountProducts, isLoading } = useCurrentProduct()
    const { localMode, merchantSummary, merchantDetailed } = useMerchant()

    const { addToCart } = useAddItem()

    if (!canAddItem || isLoading || localMode || !merchantSummary?.showProductPrice || merchantDetailed?.model?.orderingMethod === 'Disabled')
        return <></>

    const renderPrice = () => {
        return <span className={`${styles.price} font-lg`}>{(amountProducts * price).toLocalePrice()}</span>
    }

    return (
        <div className={styles.container}>
            <div className={styles.priceAndQtd}>
                {renderPrice()}
                <AddMore value={amountProducts} setValue={(a) => setAmountProducts(a)} />
            </div>
            <div className={styles.btnArea}>
                <ActionButton
                    size='medium'
                    className={styles.btnAdd}
                    onClick={() => addToCart(currentProduct!, amountProducts)}
                    svg={<SvgBag />}
                >
                    Adicionar
                </ActionButton>
            </div>
        </div>
    )
}
